<template>
    <div class="juicy-promise" @click="waterPrintStart">
        <span class="juicy-promise__text">
            Şimdiye kadar <br />
            {{ personCount }} Kişi<br />
            {{ totalTon }} Ton <br />
            tasarruf sözü verdi
        </span>
        <div class="juicy-promise__water">
            <div class="juicy-promise__wave"></div>
            <div class="juicy-promise__wave-bubble-one"></div>
            <div class="juicy-promise__wave-bubble-two"></div>
            <div class="juicy-promise__wave-bubble-three"></div>
            <div class="juicy-promise__wave-bubble-four"></div>
            <div class="juicy-promise__wave-bubble-five"></div>
            <div class="juicy-promise__wave-bubble-six"></div>
            <div class="juicy-promise__wave-bubble-seven"></div>
            <span class="juicy-promise__wave-text">SEN DE SÖZ VER!</span>
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";
    import axios from "axios";
    
    export default {
        name: "WaterPrintPromise",
        data() {
            return {
                promiseToken: '',
                totalTon: null,
                personCount : null
            }
        },
        created: function() {
            let $this = this;
            const params = new URLSearchParams();
            params.append("username", "apiuser@yarininsuyu.com");
            params.append("password", "VAv3dNfmyogCXxw9Fdi8vUBHuiqT24NVVxp0jmlvV2o=");
            params.append("grant_type", "password");

            axios.post(window.location.origin+"/oauth/token", params, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                })
                .then((response) => {
                    $this.promiseToken = response.data.access_token;
                    var config = {
                        method: 'get',
                        url: window.location.origin+'/api/WaterPrint/Details',
                        headers: { 
                            'Authorization': `Bearer ${response.data.access_token}`,
                        }
                    };
                    axios(config).then(function (response2) {
                        $this.totalTon = response2.data.model.Ton.toLocaleString().replaceAll('.',',');
                        $this.personCount = response2.data.model.Count.toLocaleString().replaceAll('.',',');
                    })
                });
        },
        watch: function(){
            
        },
        mounted: function() {
            EventBus.$on('update-ton', (value, personValue) => { this.totalTon = value.toLocaleString().replaceAll('.',','); this.personCount = personValue });
        },
        methods: {
            getUpdatePromiseTon() {
                
            },
            waterPrintStart() {
                EventBus.$emit('water-print-status');
                dataLayer.push({'event':'promiseWaterAnimation_startPromiseQuiz','page':window.location.pathname == '/' ? 'homepage' : window.location.pathname.replace('/','')});
            }   
        }
        
    }
</script>

<style lang="scss">
    .juicy-promise {
        display: flex;
        width: 263px;
        height: 202px;
        margin-right: 70px;
        flex-direction: column;
        overflow: hidden;
        border-radius: 101px;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -webkit-transform: translate3d(0, 0, 0);
        -moz-transform: translate3d(0, 0, 0);

        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            margin-bottom: 80px;
            margin-right: 0px;
            width: 520px;
            height: 450px;
            border-radius: 150px;
        }

        &__text {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            width: 100%;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                font-size: 45px;
            }
        }

        &__water {
            display: flex;
            width: 263px;
            height: 92px;
            width: 263px;
            height: 92px;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #ffffff;
            justify-content: center;
            align-items: center;
            margin-top: auto;
            position: relative;
            cursor: pointer;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                width: 100%;
            }
        }

        &__wave {
            width: 1000px;
            height: 1000px;
            position: absolute;
            bottom: -950px;
            right: -400px;
            margin-left: -500px;
            margin-top: -500px;
            border-radius: 35%;
            background-image: linear-gradient(to top, #00a0e2, #00c3ee);
            animation: wave 50s infinite linear;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                bottom: -850px;
            }

            &-text {
                position: absolute;
                font-size: 14px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #ffffff;
                z-index: 1;

                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    font-size: 30px;
                    bottom: 50px;
                }
            }

            &-bubble-one,
            &-bubble-two,
            &-bubble-three,
            &-bubble-four,
            &-bubble-five,
            &-bubble-six {
                position: absolute;
                width: 7px;
                height: 7px;
                background: paleturquoise;
                border-radius: 100%;
                top: 50%;
                left: 25%;
                -webkit-animation-name: rise;
                animation-name: rise;
                -webkit-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
                -webkit-animation-timing-function: linear;
                animation-timing-function: linear;
            }

            &-bubble-one {
                top: 50%;
                left: 20%;
                -webkit-animation-duration: 4s;
                animation-duration: 4s;
            }

            &-bubble-two {
                top: 50%;
                left: 50%;
                -webkit-animation-duration: 4s;
                animation-duration: 4s;
            }

            &-bubble-three {
                top: 50%;
                left: 70%;
                -webkit-animation-duration: 6s;
                animation-duration: 6s;
            }

            &-bubble-four {
                top: 50%;
                left: 80%;
                -webkit-animation-duration: 8s;
                animation-duration: 8s;
            }

            &-bubble-five {
                top: 50%;
                left: 20%;
                -webkit-animation-duration: 10s;
                animation-duration: 10s;
            }

            &-bubble-five {
                top: 50%;
                left: 43%;
                -webkit-animation-duration: 12s;
                animation-duration: 12s;
            }
        }

        @keyframes wave {
            from { transform: rotate(0deg); }
            from { transform: rotate(360deg); }
        }

        @-webkit-keyframes spin {
            from {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
            }
            to {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
            }
        }

        @keyframes spin {
            from {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
            }
            to {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
            }
        }

        @-webkit-keyframes rise {
            from {
                -webkit-transform: translateY(0px);
                transform: translateY(0px);
                opacity: 1;
            }
            to {
                -webkit-transform: translateY(-50px);
                transform: translateY(-50px);
                opacity: 0;
            }
        }

        @keyframes rise {
            from {
                -webkit-transform: translateY(0px);
                transform: translateY(0px);
                opacity: 1;
            }
            to {
                -webkit-transform: translateY(-50px);
                transform: translateY(-50px);
                opacity: 0;
            }
        }

    }
</style>
